/* tslint:disable */
/* eslint-disable */
/**
 * pkg/api/event.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface V1AzureDiskVolumeSource
 */
export interface V1AzureDiskVolumeSource {
    /**
     * +enum
     * @type {string}
     * @memberof V1AzureDiskVolumeSource
     */
    cachingMode?: string;
    /**
     * diskName is the Name of the data disk in the blob storage
     * @type {string}
     * @memberof V1AzureDiskVolumeSource
     */
    diskName?: string;
    /**
     * diskURI is the URI of data disk in the blob storage
     * @type {string}
     * @memberof V1AzureDiskVolumeSource
     */
    diskURI?: string;
    /**
     * fsType is Filesystem type to mount.
     * Must be a filesystem type supported by the host operating system.
     * Ex. "ext4", "xfs", "ntfs". Implicitly inferred to be "ext4" if unspecified.
     * +optional
     * @type {string}
     * @memberof V1AzureDiskVolumeSource
     */
    fsType?: string;
    /**
     * +enum
     * @type {string}
     * @memberof V1AzureDiskVolumeSource
     */
    kind?: string;
    /**
     * readOnly Defaults to false (read/write). ReadOnly here will force
     * the ReadOnly setting in VolumeMounts.
     * +optional
     * @type {boolean}
     * @memberof V1AzureDiskVolumeSource
     */
    readOnly?: boolean;
}

export function V1AzureDiskVolumeSourceFromJSON(json: any): V1AzureDiskVolumeSource {
    return V1AzureDiskVolumeSourceFromJSONTyped(json, false);
}

export function V1AzureDiskVolumeSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): V1AzureDiskVolumeSource {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'cachingMode': !exists(json, 'cachingMode') ? undefined : json['cachingMode'],
        'diskName': !exists(json, 'diskName') ? undefined : json['diskName'],
        'diskURI': !exists(json, 'diskURI') ? undefined : json['diskURI'],
        'fsType': !exists(json, 'fsType') ? undefined : json['fsType'],
        'kind': !exists(json, 'kind') ? undefined : json['kind'],
        'readOnly': !exists(json, 'readOnly') ? undefined : json['readOnly'],
    };
}

export function V1AzureDiskVolumeSourceToJSON(value?: V1AzureDiskVolumeSource | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'cachingMode': value.cachingMode,
        'diskName': value.diskName,
        'diskURI': value.diskURI,
        'fsType': value.fsType,
        'kind': value.kind,
        'readOnly': value.readOnly,
    };
}

